import getLignesCommandesWithReferenceEcheancier
  from '@/services/commande/echeancierFacturation/getLignesCommandesWithReferenceEcheancier';
import { addReferenceEcheancierToLigneCommande }
  from '@/services/commande/echeancierFacturation/addReferenceEcheancierToLigneCommande';
import deleteLignesEcheanciersInutiles
  from '@/services/commande/echeancierFacturation/deleteLignesEcheanciersInutiles';

export default function defusionEcheancier(referencesEcheanciers, commande) {
  referencesEcheanciers.forEach((referenceEcheancier) => {
    const lignes = getLignesCommandesWithReferenceEcheancier(
      commande.lignesCommande, referenceEcheancier,
    );
    lignes.forEach((ligne) => {
      addReferenceEcheancierToLigneCommande(ligne, commande);
    });
  });
  deleteLignesEcheanciersInutiles(commande);
}
